module.exports = __webpack_public_path__ + "img/graphic_warning_yellow.83872041.svg";